import { __rest } from "tslib";
import * as React from 'react';
export var LoginFooterItem = function LoginFooterItem(_a) {
  var _a$className = _a.className,
      className = _a$className === void 0 ? '' : _a$className,
      _a$children = _a.children,
      children = _a$children === void 0 ? null : _a$children,
      _a$href = _a.href,
      href = _a$href === void 0 ? '#' : _a$href,
      _a$target = _a.target,
      target = _a$target === void 0 ? '_blank' : _a$target,
      props = __rest(_a, ["className", "children", "href", "target"]);

  return React.isValidElement(children) ? children : React.createElement("a", Object.assign({
    target: target,
    href: href
  }, props), children);
};